// extracted by mini-css-extract-plugin
export default {"container":"_5b33c60a","wrapper":"_958872de","header":"_88a6eaf2","link":"_48646eed","arrow":"_e02e8f94"};